<template>
  <SlideYDownTransition>
    <div class="location-filters"
         v-show="isOpen">
      <h2 class="locations-filter__title">
        {{ $t('filter-per-category') }}
      </h2>
      <div class="buttons">

        <a href="#" data-active="false" data-filter="Fontata pubblica"
           class="location-filter location-filter--public"
           @click="toggleMarkers('Fontata pubblica', $event)">
          <img class="detail-icon" src="@/assets/icons/fontana-pubblica.svg"
               alt="">
          <span class="location-filter__label">
          {{ $t('public-water') }}
        </span>
        </a>
        <a href="#" data-active="false" data-filter="Partner"
           class="location-filter location-filter--partner"
           @click="toggleMarkers('Partner', $event)">
          <img class="detail-icon" src="@/assets/icons/partner.svg"
               alt="">
          <span class="location-filter__label">
          {{ $t('partner') }}
        </span>
        </a>
        <a href="#" data-active="false" data-filter="Punto di acquisto"
           class="location-filter location-filter--punto"
           @click="toggleMarkers('Punto Di Acquisto', $event)">
          <img class="detail-icon" src="@/assets/icons/punto-di-acquisto.svg"
               alt="">
          <span class="location-filter__label">
          {{ $t('refill-now-shop') }}
        </span>
        </a>
      </div>
    </div>
  </SlideYDownTransition>
</template>

<script>

import { SlideYDownTransition } from 'vue2-transitions'
import { Event } from '@/main'

export default {
  name: 'LocationFilters',
  components: {
    SlideYDownTransition
  },
  data () {
    return {
      filtered: false,
      filters: document.getElementsByClassName('location-filter')
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    marker: {
      type: Object
    }
  },
  methods: {
    toggleMarkers (type, event) {
      // Current filter var
      const currentFilter = event.currentTarget

      // Save current state
      const initialState = JSON.parse(currentFilter.getAttribute('data-active').toLowerCase())

      // Set all filters no inactive
      for (const filter of this.filters) {
        filter.setAttribute('data-active', false)
      }

      currentFilter.setAttribute('data-active', !initialState)

      Event.$emit('filterMarkers', { type, initialState })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.location-filters {
  max-width: 380px;
  padding: 10px 20px 15px;
  background: white;
  margin: auto auto 0;
  border-top-right-radius: 60px;
  border-top-left-radius: 60px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 -7px 25px;
  text-align: center;
  z-index: 15;

  .buttons {
    display: flex;
  }
}

.location-filter {
  margin: 0 10px;
  width: 33%;

  &__label {
    font-weight: bold;
  }

  img {
    border-radius: 50%;
    border: thick solid gainsboro;
    margin-bottom: 10px;
    height: 93px;
    padding: 20px;
    width: 100%;
  }

  span {
    color: #afafaf;
  }

  &--public[data-active="true"] img {
    border-radius: 50%;
    border-color: $green;
  }

  &--public[data-active="true"] span {
    font-weight: bold;
    color: $green;
  }

  &--partner[data-active="true"] img {
    border-radius: 50%;
    border-color: $blue-dark;
  }

  &--partner[data-active="true"] span {
    font-weight: bold;
    color: $blue-dark;
  }

  &--punto[data-active="true"] img {
    border-radius: 50%;
    border-color: $blue-light;
  }

  &--punto[data-active="true"] span {
    font-weight: bold;
    color: $blue-light;
  }
}

.locations-filter__title {
  text-align: left;
  width: 100%;
  display: block;
  margin-left: 20px;
  margin-bottom: 20px;
  font-size: 23px;
}

</style>
